module.exports = __webpack_public_path__ + "img/lg.3d6b72ed.svg";